<script setup lang="ts" generic="T extends string">
import { useForwardPropsEmits } from "reka-ui";
import { injectItemContext } from ".";
import KeyboardShortcut, {
	type KeyboardShortcutEmits,
	type KeyboardShortcutProps,
} from "../keyboard/KeyboardShortcut.vue";

const props = withDefaults(defineProps<KeyboardShortcutProps<T>>(), { size: "sm" });
const emits = defineEmits<KeyboardShortcutEmits>();

const forwarded = useForwardPropsEmits(props, emits);

const itemContext = injectItemContext();

function onActive() {
	itemContext.select?.();
}
</script>

<template>
	<KeyboardShortcut
		class="text-muted-content ml-auto tracking-widest"
		v-bind="forwarded"
		@active="onActive"
	>
		<slot />
	</KeyboardShortcut>
</template>
